import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id in URL');
          navigate('/');
          return;
        }

        // Exchange session_id for session_token
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId }),
          
        });

        if (!response.ok) {
          throw new Error('Auth failed');
        }

        const userData = await response.json();
        
        // Store user data in localStorage for compatibility with existing auth
        if (userData.role === 'patient') {
          localStorage.setItem('patientToken', userData.session_token);
          localStorage.setItem('patientData', JSON.stringify(userData));
          // Clear URL and redirect to patient dashboard
          window.history.replaceState({}, document.title, '/mon-espace');
          navigate('/mon-espace', { state: { user: userData } });
        } else if (userData.role === 'veterinarian') {
          localStorage.setItem('vetToken', userData.session_token);
          localStorage.setItem('vetData', JSON.stringify(userData));
          window.history.replaceState({}, document.title, '/espace-veterinaire');
          navigate('/espace-veterinaire', { state: { user: userData } });
        } else {
          // Default to patient space
          localStorage.setItem('patientToken', userData.session_token);
          localStorage.setItem('patientData', JSON.stringify(userData));
          window.history.replaceState({}, document.title, '/mon-espace');
          navigate('/mon-espace', { state: { user: userData } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-green-600 mx-auto mb-4" />
        <p className="text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
